import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { Row, Col, Checkbox } from "@folio/stripes/components";
import { PublisherAddress } from "./PublisherAddress";
export var PublisherAddressSection = function (_a) {
    var _b;
    var control = _a.control, errors = _a.errors, setValue = _a.setValue, regionsData = _a.regionsData, showMailingAddress = _a.showMailingAddress, setShowMailingAddress = _a.setShowMailingAddress;
    var formatMessage = useIntl().formatMessage;
    var regions = (_b = regionsData === null || regionsData === void 0 ? void 0 : regionsData.items) !== null && _b !== void 0 ? _b : [];
    var handleToggleShowMailingAddress = function () {
        var newValue = !showMailingAddress;
        setShowMailingAddress(newValue);
        if (newValue) {
            setValue("mailingAddress", {
                street: "",
                postalCode: "",
                municipality: "",
                regionId: "",
            });
        }
        else {
            setValue("mailingAddress", undefined);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h4", null,
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.publishers.accordion.mainAddress" })),
        React.createElement(PublisherAddress, { type: "mainAddress", control: control, errors: errors, regions: regions, setValue: setValue }),
        React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(Checkbox, { label: formatMessage({
                        id: "ui-br-legaldeposits.publishers.field.showMailingAddress",
                    }), checked: showMailingAddress, onChange: handleToggleShowMailingAddress }))),
        showMailingAddress && (React.createElement(React.Fragment, null,
            React.createElement(PublisherAddress, { type: "mailingAddress", control: control, errors: errors, regions: regions, setValue: setValue })))));
};
